/**
 * Shared display-name initials for document logos and avatar chips.
 */
export function initials(name: string): string {
  const parts = name.split(/\s+/).filter(Boolean);
  return `${parts[0]?.[0] ?? "C"}${parts[1]?.[0] ?? parts[0]?.[1] ?? "U"}`.toUpperCase();
}
